module.exports = __webpack_public_path__ + "static/img/7.5368b00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/global/7.png
// module id = V5kC
// module chunks = 1